import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	sectionLabel: {
		fontSize: "0.75rem",
		fontWeight: 600,
		color: themeColors.colors.system.gray[500],
		textTransform: "uppercase",
		letterSpacing: "0.05em"
	},
	scoreColumn: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center"
	},
	scoreOutOf: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500]
	},
	scoreBadgeWithDot: {
		display: "inline-flex",
		alignItems: "center",
		gap: "6px",
		borderRadius: "999px",
		padding: "4px 12px",
		fontSize: "0.75rem",
		fontWeight: 600
	},
	scoreBadgeDot: {
		width: "8px",
		height: "8px",
		borderRadius: "50%",
		display: "inline-block"
	},
	topicSubCard: {
		padding: "12px",
		border: `1px solid ${themeColors.colors.system.gray[200]}`,
		borderRadius: "10px",
		backgroundColor: themeColors.colors.base.white,
		minHeight: 160,
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "8px"
	},
	topicLabelFixedWidth: {
		maxWidth: 132
	},
	topicWeightPill: {
		display: "inline-flex",
		alignItems: "center",
		borderRadius: "999px",
		minWidth: 68,
		padding: "2px 8px",
		fontSize: "0.7rem",
		fontWeight: 500,
		color: themeColors.colors.system.gray[600],
		backgroundColor: themeColors.colors.system.gray[100]
	},
	topicScoreLarge: {
		fontSize: "1.5rem",
		fontWeight: 700
	},
	topicScoreOutOf: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500]
	},
	topicQualityLabel: {
		fontSize: "0.75rem",
		fontWeight: 400,
		color: themeColors.colors.system.gray[500]
	},
	topicProgressBar: {
		backgroundColor: themeColors.colors.success[600]
	},
	topicProgressTrack: {
		backgroundColor: themeColors.colors.system.gray[200],
		borderRadius: "4px",
		height: "6px"
	}
}))

export default useStyles
